import type { LimitOrderInputForm } from 'state/secondaryMarket/limit-order/form/input/inputForm.model';
import type { SecondaryMarketLimitOrderReloadedForm } from 'state/secondaryMarket/limit-order/form/original/original.model';
import type { FormType } from 'state/secondaryMarket/shared/form/form.model';
import type { AppState } from 'state/state.model';

export const limitOrderFormSelectorFactory = <Form extends SecondaryMarketLimitOrderReloadedForm | LimitOrderInputForm>(
  formType: FormType,
) => {
  const select = (state: AppState, tabId: string) => {
    return state.secondaryMarket.limitOrder.form[formType][tabId] as Form;
  };
  const getLimit = (state: AppState, tabId: string) => select(state, tabId)?.limit;
  const getSalesMarginAdjustment = (state: AppState, tabId: string) => select(state, tabId)?.salesMarginAdjustment;
  return {
    select,
    getLimit,
    getSalesMarginAdjustment,
  };
};
